import React, { useState } from "react";
import { 
    Card, CardActions, CardContent, CardHeader, 
    IconButton, TextField, List, ListItem, 
    Checkbox, FormControlLabel, FormGroup, 
    Divider, Grid, Fab, Typography, Popover
} from "@material-ui/core";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import RefreshIcon from '@material-ui/icons/Refresh';
import { createMarkup, remoteURL, scrollTop, testerArr } from "../common";
import ModalImages from "../components/ModalImages";
import ReactCardFlip from 'react-card-flip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faInfo, faInfoCircle
} from '@fortawesome/free-solid-svg-icons'

import { isIOS, isAndroid } from 'react-device-detect';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { LabsComponent } from "./LabComponent";
import { ReviewSlider } from "./ReviewSlider";

import "../styles/masterStyles.css";
import { Redirect } from "react-router";

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 345,
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    }
}));

export const QuestionQuizCard   = props => {
    const referenceURI = 'https://university.auanet.org/mobileapps/sasp/resources/references.cfm?questionid=' + props.obj.questionID + '&questionnumber=' + props.obj.questionNumber + '&id=' + props.mcid + '&key=' + props.mykey;

    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);
    const [flipped, setFlipped] = React.useState(false);

    const [answer, setAnswer] = useState(null);
    const [answerid, setAnswerID] = useState(null);
    const [correct, setCorrect] = useState(null);
    const [next, setNext] = useState(null);
    const [prev, setPrev] = useState(null);

    const correctObj = props.obj.qoptions.filter(item => item.AnswerOptionCorrect === 1);

    const _OBJ = {
        mcid: props.mcid,
        questionid: props.obj.questionID,
        key: props.mykey,
        year: props.year,
        gamemode: props.gamemode
    }

    const owner = 0;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [value, setValue] = useState('');

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const addQuestion = async (obj) => {
        if (obj.send) {
            await props.addToDecks(obj.questionID, obj.deckID);
            if (obj.id) {
                let element = document.getElementById(obj.id);
                if (element) {
                    try {
                        element.className = "hidden"
                    } catch (e) {
                    }
                }
            }
        }
    }

    const handleFABClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleFABRemove = async () => {
        const removeCallBack = async (index) => {
            if (isAndroid) {
                switch (index) {
                    case 1: {
                        return props.resetTest();
                    }
                    default: {
                        return false;
                    }
                }
            } else if (isIOS) {
                switch (index) {
                    case 1: {
                        return props.resetTest(); 
                    }
                    default: {
                        return false;
                    }
                }
            } else {
                switch (index) {
                    case 1: {
                        return props.resetTest();
                    }
                    default: {
                        return false;
                    }
                }
            }
            
        }

        return navigator.notification.confirm(`Are you sure you want to reset this test?`, removeCallBack, 'Reset Test', ['Reset', 'Cancel']);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleBlur = async (event) => {
        let obj = {
            mcid: props.mcid,
            key: props.mykey,
            comment: value,
            gameMode: Number(props.gamemode),
            questionID: props.obj.questionID
        }

        switch(Number(props.gamemode)) {
            case 1:
            case 2: {
                obj.yearvar = props.obj.availableyears;
                break;
            }

            case 3:
            case 4:
            case 9:
            case 10:
            case 11:
            case 12: {
                obj.deckID = props.deckid;
                break;
            }
        }

        let elem = document.getElementById('questioncomment-multiline-flexible');
        if (elem) {
            elem.classList.add('active-text-field');
        }
        await props.addNote(obj);
    }

    const handleSelect = (obj) => {
        props.selectFunc(obj);
        setCorrect(Number(obj.correct))
        setAnswerID(Number(obj.id))
        setNext(Number(obj.next))
        setPrev(Number(obj.prev))
        return setAnswer(Number(obj.index));
    }

    const handleNext = () => {
        let _next = _OBJ;
        _next.index = props.index;
        _next.next = true;

        setAnswer(null);
        setAnswerID(null);
        setCorrect(null);

        return props.submitFunc(_next)
    }

    const handlePrev = () => {
        let _prev = _OBJ;
        _prev.index = props.index;
        _prev.prev = true;
        _prev.next = null;

        setAnswer(null);
        setAnswerID(null);
        setCorrect(null);

        return props.submitFunc(_prev)
    }

    const handleSubmit = (obj) => {
        if (typeof obj.next !== 'undefined') {
            setAnswer(null);
            setAnswerID(null);
            setCorrect(null);
        }

        return props.submitFunc(obj)
    }

    const handleFlipCard = () => {
        return setFlipped(!flipped);
    }

    const flipCard = () => {
        if (typeof props.id === 'string') {
            scrollTop(props.id, -64);
        }
        
        return handleFlipCard();
    }

    const mapQuestions = () => {
        if (props.obj.qoptions) {
            return props.obj.qoptions.map((item, index) => {

                let gridClass = 'sasp-answer-item';
                const _hsobj = {
                    index: index, 
                    id: item.AnswerOptionID, 
                    correct: item.AnswerOptionCorrect, 
                    next: props.obj.nextQuestionID, 
                    prev: props.obj.previousQuestionID
                }

                if (props.answered < 0) {
                    if (index === answer) {
                        gridClass += ' sasp-selected'
                    } else if (typeof props.prevAnswer === 'object') {
                        if (
                            typeof props.prevAnswer.index !== 'undefined' && 
                            index === props.prevAnswer.index &&
                            answer === null &&
                            (props.gamemode < 3 || (props.gamemode >= 9 && props.gamemode <= 12))
                        ) {
                            gridClass += ' sasp-selected'
                        }
                    }
                } else if (props.answered > 0) {
                    if (item.AnswerOptionCorrect) {
                        gridClass += ' sasp-selected sasp-correct'
                    } else if (index === answer && !item.AnswerOptionCorrect) {
                        gridClass += ' sasp-selected sasp-wrong'
                    }
                } else if (item.selected === 1 && (item.selected === item.AnswerOptionCorrect) ) {
                    gridClass += ' sasp-selected sasp-correct'
                } else if (item.selected === 1 && (item.selected !== item.AnswerOptionCorrect) ) {
                    gridClass += ' sasp-selected sasp-wrong'
                }  
            
                return (
                    <div
                        className={gridClass}
                        onClick={props.answered < 0 ? () => handleSelect(_hsobj) : () => {}}
                    >
                        <div
                            className="flex-row-question width100"
                        >
                            <div className="">{item.AnswerOptionLetter}.</div>
                            <div 
                                className="margin-left-16 margin-right-4"
                                dangerouslySetInnerHTML={createMarkup(item.AnswerOption)} 
                            />

                            {item.AnswerOptionCorrect && props.answered > 0 || (testerArr.includes(props.mcid) && item.AnswerOptionCorrect )
                                ? (
                                    <div>
                                        <CheckIcon style={{fontSize: "1.15em"}} />
                                    </div>
                                ) : null
                            }

                            {index === answer && 
                             !item.AnswerOptionCorrect && 
                             props.answered > 0 
                                ? (
                                    <div>
                                        <CloseIcon style={{fontSize: "1.15em"}} />
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                );
            });
        }
    }

    const showQuestion = () => {
        return (
            <CardContent >
                <div 
                    className="margin-bottom-16"
                    dangerouslySetInnerHTML={createMarkup(props.obj.questionText)} 
                />

                {typeof props.obj.qImages !== 'undefined' && props.obj.qImages.length > 0
                    ? (
                        <div className="padding-top-16">
                            <ModalImages 
                                qImages={props.obj.qImages}
                                title={`SASP ${props.obj.QuestionYear} Question ${props.obj.questionNumber}`}
                                style={{paddingTop:'16px !important'}}
                            />
                        </div>
                    ) : null
                }

                <div className="width100 margin-top-16 margin-bottom-16">
                    {mapQuestions()}
                </div>

                {
                    props.answered > 0 && 
                    (props.gamemode !== 2 || props.gamemode !== 4 || props.gamemode !== 10 || props.gamemode !== 12)
                    ? (
                        <div className="width100 margin-top-16 margin-bottom-16">
                            {typeof props.obj.explanation !== 'undefined'
                                ? (
                                    <>
                                        <Typography 
                                            className="DividerText anchor"
                                        >
                                            Explanation
                                        </Typography>
                                        <Divider className="SASPDivider" />
                                        <div 
                                            dangerouslySetInnerHTML={createMarkup(props.obj.explanation ? props.obj.explanation : '')} />
                                    </>
                                ) : null
                            }

                            <Divider className="SASPDivider" />

                            <div 
                                className="text-blue text-strong text-center margin-top-16 margin-bottom-16"
                                onClick={() => flipCard()}
                            >
                                View Details
                            </div>
                        </div>
                    ) : null
                }
            </CardContent>
        )
    }

    const reset = (obj) => {
        return props.resetDeck(obj);
    }

    const mapActionBtn = () => {
        let _submit = _OBJ;

        _submit.correct = correct;
        _submit.answerid = answerid;

        if (
            (Number(props.gamemode) === 2 || Number(props.gamemode) === 4 || Number(props.gamemode) === 10 || Number(props.gamemode) === 12) ||
            props.answered > 0
        ) {
            if (answer !== null || props.answered > 0) {
                if (answer !== null) {
                    _submit.next = 1;
                }
                
                return (
                    <div 
                        className="sasp-submit-btn"
                        onClick={() => handleSubmit(_submit)}
                    >
                        Next
                    </div>
                )
            } else {
                return (
                    <div className="sasp-submit-btn disabled">
                        Next
                    </div>
                )
            }
        } else {
            let _classes = 'sasp-submit-btn';

            if (answer !== null) {
                return (
                    <div 
                        className={_classes}
                        onClick={() => handleSubmit(_submit)}
                    >
                        Submit
                    </div>
                )
            } else {
                _classes += ' disabled'
                return (
                    <div 
                        className={_classes}
                    >
                        Submit
                    </div>
                )
            }
            
        }
    }

    let prevClass = 'firstButton ';
    let showPrev = 1;

    if (props.index < 1) {
        prevClass += 'disabled';
        showPrev = 0;
    } 
    
    if (props.gamemode === 1 && props.answered > 0) {
        prevClass += 'disabled';
        showPrev = 0;
    }

    let __typetext = props.typetext;

    try {
        if (props.prevAnswer.answered) {
            // __typetext += ' (previously answered)';
        }
    } catch (e) {
    }

    return (
        <>
            {(props.gamemode < 3 || owner) || (props.gamemode >= 9 && props.gamemode <= 12)
                ? (
                    <div className="sasp-fab-container-vertical">
                        <Fab
                            size="small"
                            className="margin-bottom-4"
                            style={{background: "var(--aua-app-background-grad-linear-dark-grey)", color: '#fff'}}
                            aria-label="remove"
                            onClick={handleFABRemove}
                            InDecks={props.obj.InDecks}
                        >
                            <RefreshIcon className="text-white"/>
                        </Fab>

                        <Fab
                            size="small"
                            className="margin-bottom-4"
                            style={{background: 'var(--aua-app-background-grad-linear-med-light-green)', color: '#fff'}}
                            aria-label="add"
                            onClick={handleFABClick}
                            InDecks={props.obj.InDecks}
                        >
                            <AddIcon className="text-white"/>
                        </Fab>

                        <Fab
                            size="small"
                            className="margin-bottom-4"
                            style={{background: "var(--aua-app-background-grad-linear-blue)", color: '#fff'}}
                            aria-label="remove"
                            onClick={() => props.handleReview(1)} 
                            InDecks={props.obj.InDecks}
                        >
                            <CheckCircleIcon  className="text-white"/>
                        </Fab>
                        
                        <Popover
                            id={id}
                            className="margin-bottom-4"
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            <List dense={true}>
                                <ListItem>
                                    <FormGroup row>
                                        <FormControlLabel 
                                            control={
                                                <Checkbox 
                                                    onChange={(event) => addQuestion({
                                                        questionID: props.obj.questionID, 
                                                        gameMode: props.obj.gameMode,
                                                        deckID: null,
                                                        send: event.target.checked
                                                    })}
                                                />
                                            }
                                            label="Add to All Decks"
                                        />
                                        
                                    </FormGroup>
                                </ListItem>
                                <Divider />

                                {props.deckList.map((row, index) => (
                                    <ListItem id={"FABList_" + row.deckID}>
                                        <FormGroup row>
                                            <FormControlLabel 
                                                control={
                                                    <Checkbox 
                                                        onChange={(event) => addQuestion({
                                                            gameMode: props.obj.gameMode, 
                                                            deckID: row.deckID,
                                                            questionID: props.obj.questionID,
                                                            send: event.target.checked,
                                                            id:"FABList_" + row.deckID
                                                        })}
                                                        className='text-grey'
                                                        checked={(props.obj.InDecks.includes(row.deckID)) ? true : false}
                                                    />
                                                }
                                                label={row.deckname.length ? row.deckname : `My Deck ${index}`}
                                            />
                                        </FormGroup>
                                    </ListItem>
                                ))}
                            </List>
                        </Popover>

                        <LabsComponent 
                            labs={props.labs} 
                            gamemode={props.gamemode}
                            year={props.year}
                            deckid={props.deckid}
                            mcid={props.mcid}
                            mykey={props.mykey}
                            resetDeck={reset}
                        />
                    </div>
                )
                : (
                    <div className="sasp-fab-container-vertical">
                        <Fab
                            size="small"
                            className="margin-bottom-4"
                            style={{backgroundColor: "#97A19C", color: '#fff'}}
                            aria-label="remove"
                            onClick={() => handleFABRemove()}
                            InDecks={props.obj.InDecks}
                        >
                            <RemoveIcon className="text-white"/>
                        </Fab>

                        <LabsComponent 
                            labs={props.labs}
                            gamemode={props.gamemode}
                            year={props.year}
                            deckid={props.deckid}
                            mcid={props.mcid}
                            mykey={props.mykey}
                            resetDeck={reset}
                        />
                    </div>
                )
            }
            <ReactCardFlip isFlipped={flipped} flipDirection="horizontal" infinite={true} className="width100">
                <Card 
                    className="width100 margin-bottom-8"
                >
                    {props.answered > 0 && props.type === 'open'
                        ? (
                            <CardHeader 
                                title={`SASP ${props.obj.QuestionYear} Question ${props.obj.questionNumber}`}
                                subheader={`${__typetext}`}
                                action={
                                    <IconButton
                                        className="firstButton"
                                        edge="start"
                                        aria-label="firstIcon"
                                        onClick={() => flipCard()}
                                        style={{marginRight: '16px'}}
                                        // style={{backgroundColor: '#00567a', transform:"scale(0.67)"}}
                                    >
                                        {/* <InfoOutlinedIcon className="headerIcons" /> */}
                                        <FontAwesomeIcon 
                                            className="text-blue" 
                                            icon={faInfoCircle} 
                                            style={{
                                                fontSize: '1.5rem',
                                                position: 'relative',
                                                top: '-8px'
                                            }}
                                        />
                                    </IconButton>
                                }

                                style={{
                                    backgroundColor: "#f1f3f5"
                                }}
                            />
                        )
                        : (
                            <CardHeader 
                                title={`SASP ${props.obj.QuestionYear} Question ${props.obj.questionNumber}`}
                                subheader={`${__typetext}`}
                                style={{
                                    backgroundColor: "#f1f3f5"
                                }}
                            />
                        )
                    }
                    
                    {showQuestion()}

                    <CardActions
                        style={{
                            display:"flex",
                            flexDirection:"row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 16px",
                            backgroundColor: "#f1f3f5"
                        }}
                    >
                        {!props.review && ((props.gamemode < 3 && showPrev) || (props.gamemode >= 9 && props.gamemode <= 12 && showPrev))
                            ? (
                                <IconButton
                                    className={prevClass}
                                    edge="start"
                                    aria-label="firstIcon"
                                >
                                    
                                </IconButton>
                            ): (
                                <IconButton
                                    className={prevClass}
                                    edge="start"
                                    aria-label="firstIcon"
                                    style={{opacity: '0.5', cursor: 'not-allowed'}}
                                >
                                    
                                </IconButton>
                            )
                        }

                        {mapActionBtn()}

                        {props.review
                            ? (
                                <IconButton
                                    className={clsx(classes.expand, {
                                        [classes.expandOpen]: expanded,
                                    })}
                                    edge="start"
                                    aria-label="firstIcon"
                                    style={{opacity: '0.5', cursor: 'not-allowed'}}
                                >
                                    
                                </IconButton>
                            ) : (
                                <IconButton
                                    className={clsx(classes.expand, {
                                        [classes.expandOpen]: expanded,
                                    })}
                                >
                                    
                                </IconButton>
                            )
                        }
                            
                    </CardActions>
                </Card>

                <Card 
                    className="width100 margin-bottom-8"
                >
                    <CardHeader 
                        title={`SASP ${props.obj.QuestionYear} Question ${props.obj.questionNumber}`}
                        subheader={`${__typetext}`}
                        action={
                            <IconButton
                                className="firstButton"
                                edge="start"
                                aria-label="firstIcon"
                                onClick={() => flipCard()}
                                // style={{backgroundColor: '#00567a', transform:"scale(0.67)"}}
                            >
                                {/* <InfoOutlinedIcon className="headerIcons" /> */}
                                <FontAwesomeIcon 
                                    className="text-blue" 
                                    icon={faInfoCircle} 
                                    style={{
                                        fontSize: '1.5rem',
                                        position: 'relative',
                                        top: '-8px'
                                    }}
                                />
                            </IconButton>
                        }

                        style={{
                            backgroundColor: "#f1f3f5"
                        }}
                    />

                    <CardContent>
                        <Grid item xs={12}>
                            <Typography 
                                className="DividerText anchor"
                            >
                                Answer
                            </Typography>
                            <Divider className="SASPDivider" />
                            <div><p><strong>{correctObj[0].AnswerOption}</strong></p></div>
                        </Grid>

                        {typeof props.obj.qImages !== 'undefined' && 
                            props.obj.qImages.length > 0
                            ? (
                                <div className="padding-top-16">
                                    <ModalImages 
                                        qImages={props.obj.qImages}
                                        title={`SASP ${props.obj.QuestionYear} Question ${props.obj.questionNumber}`}
                                        style={{paddingTop:'16px !important'}}
                                    />
                                </div>
                            ) : null
                        }

                        {typeof props.obj.explanation !== 'undefined'
                            ? (
                                <Grid item xs={12}>
                                    <Typography 
                                        className="DividerText anchor"
                                    >
                                        Explanation
                                    </Typography>
                                    <Divider className="SASPDivider" />
                                    <div 
                                        dangerouslySetInnerHTML={createMarkup(props.obj.explanation ? props.obj.explanation : '')} />
                                </Grid>
                            ) : null
                        }

                        {typeof props.obj.reference !== 'undefined'
                            ? (
                                <Grid item xs={12}>
                                    <Typography 
                                        className="DividerText anchor"
                                    >
                                        References

                                        <div
                                            style={{
                                                position:"absolute",
                                                right: "0",
                                                top: "8px",
                                                display:"flex",
                                                flexDirection:"column",
                                                justifyContent:"center",
                                                alignItems:"center"
                                            }}
                                        >
                                            <a 
                                                onClick={() => remoteURL(referenceURI)}
                                            >
                                                <ExitToAppIcon className="text-blue" />
                                            </a>
                                        </div>
                                    </Typography>
                                    <Divider className="SASPDivider" />
                                    <div 
                                        dangerouslySetInnerHTML={createMarkup(props.obj.reference ? props.obj.reference : '')} 
                                    />
                                </Grid>
                            ) : null
                        }

                        <div className="width100 margin-top-16 margin-bottom-16">
                            <Divider className="SASPDivider" />

                            <div 
                                className="text-blue text-strong text-center margin-top-16 margin-bottom-16"
                                onClick={() => flipCard()}
                            >
                                View Answer
                            </div>
                        </div>
                    </CardContent>

                    <CardActions
                        style={{
                            display:"flex",
                            flexDirection:"row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 16px",
                            backgroundColor: "#f1f3f5"
                        }}
                    >
                        {props.gamemode < 3 && showPrev
                            ? (
                                <IconButton
                                    className={prevClass}
                                    edge="start"
                                    aria-label="firstIcon"
                                    // onClick={props.obj.previousQuestionID > 0 ? () => handlePrev() : () => {return null}}
                                >
                                    {/* <ArrowBackIcon /> */}
                                </IconButton>
                            ): (
                                <IconButton
                                    className={prevClass}
                                    edge="start"
                                    aria-label="firstIcon"
                                    style={{opacity: '0.5', cursor: 'not-allowed'}}
                                >
                                    {/* <ArrowBackIcon /> */}
                                </IconButton>
                            )
                        }

                        {mapActionBtn()}

                        <IconButton
                            className={clsx(classes.expand, {
                                [classes.expandOpen]: expanded,
                            })}
                            // onClick={() => handleNext()}
                        >
                            {/* <ArrowForwardIcon /> */}
                        </IconButton>
                    </CardActions>
                </Card>
            </ReactCardFlip>

            {props.gamemode > 2 && props.spaced && props.answered > 0
                ? (
                    <div className="width100 margin-top-24">
                        <ReviewSlider 
                            gameMode={props.gamemode}
                            questionID={props.obj.questionID}
                            deckID={props.deckid}
                            mcid={props.mcid}
                            myKey={props.mykey}
                            putNextReviewDate={props.putNextReviewDate}
                        />
                    </div>
                ) : null
            }

            <div className="width100 margin-top-24 margin-bottom-24">
                <Typography className="DividerText ">
                    Add Note
                </Typography>
                <Divider className="SASPDivider " />

                <form noValidate autoComplete="off" className="">
                    <TextField
                        id="questioncomment-multiline-flexible"
                        label=""
                        multiline
                        rowsMax={10}
                        rows={3}
                        value={value}
                        onChange={handleChange} 
                        onBlur={handleBlur}
                        className="width100"
                    />
                </form>
            </div>
        </>
    );
};